import React from "react";
import { shallowEqual } from "react-redux";
import type { MODAL_USC_BASKET_DETAILS } from "../../../utils/modalConstants";
import { useUscSelector } from "../../../redux/store";
import UscFinanceToggle from "../common/basket/common/UscFinanceToggle";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import ModalBaseView from "../../../../shared-components/toyota/styles/organisms/Modal";
import * as ModalStyles from "../../../../shared-components/toyota/styles/organisms/Modal.styles";
import * as Styles from "./UscBasketDetailsModal.styles";
import Icon from "../../../../shared-components/toyota/styles/atoms/Icon";
import Text from "../../../../shared-components/toyota/styles/atoms/Text";
import Button from "../../../../shared-components/toyota/styles/atoms/Button";
import Sidebar from "../styles/atoms/Sidebar";
import Content from "../styles/atoms/Content";
import { UscTrackingLocation } from "../../../utils/tracking";
import UscBasketDetails from "../common/basket/UscBasketDetails";
import { shouldShowPriceBreakdownSelector } from "../../../utils/basketUtils";
import { UscLabel } from "../../../utils/labels";
import { CommonLabel } from "../../../../../common-deprecated/utils/commonLabels";

export type UscBasketDetailsModalType = {
    type: typeof MODAL_USC_BASKET_DETAILS;
};

const UscBasketDetailsModal = (props: ModalViewType<UscBasketDetailsModalType>): JSX.Element | null => {
    const { show, close, modalSettings } = props;
    const result = useUscSelector((state) => state.vehicle.result);
    const shouldShowPriceBreakdown = useUscSelector(shouldShowPriceBreakdownSelector, shallowEqual);

    if (!result) return null;

    return (
        <ModalBaseView
            modalIdType={modalSettings.type}
            onClose={close}
            size="fullscreen"
            show={show}
            disableOutsideClick
            dialogLabelId="uscBasketDetailsTitle"
            dialogDescId="uscBasketDetailsDesc"
        >
            <ModalStyles.Header bgColour="grey-1">
                <div>
                    <Text id="uscBasketDetailsTitle" tag="h2" variant="h6">
                        <UscLabel label="uscBasketTitle" />
                    </Text>
                </div>
                <ModalStyles.Button type="button" onClick={close}>
                    <Icon variant="close" />
                </ModalStyles.Button>
            </ModalStyles.Header>
            <ModalStyles.Body noSpacing>
                <Styles.ContentWrapper>
                    <Content>
                        <Styles.Details>
                            <div>
                                <UscFinanceToggle trackingLocation={UscTrackingLocation.BasketDetails} inModal />
                            </div>
                            <UscBasketDetails showPriceBreakdown={shouldShowPriceBreakdown} />
                        </Styles.Details>
                    </Content>
                    <Sidebar variant="basket-details">
                        <Styles.Actions>
                            <Button variant="primary" size="fullwidth" onClick={close}>
                                <CommonLabel label="close" />
                            </Button>
                        </Styles.Actions>
                    </Sidebar>
                </Styles.ContentWrapper>
            </ModalStyles.Body>
        </ModalBaseView>
    );
};

export default UscBasketDetailsModal;
